import React from 'react';
import { Inspector as RawInspector, InspectorProps } from 'react-dev-inspector';

const InspectorWrapper =
  process.env.NODE_ENV === 'production' ? React.Fragment : RawInspector;

const Inspector: React.FC<InspectorProps> = ({ children }) => {
  return (
    <InspectorWrapper keys={['control', 'shift', '/']}>
      {children}
    </InspectorWrapper>
  );
};

export default Inspector;
